const heading = 'px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'
const cell = 'px-6 py-4 whitespace-nowrap text-sm text-gray-500'

export const styles = {
  heading,
  cell
}
